import {Component, Input} from '@angular/core';
import {CustomerProfile} from '../../../modules/customers/shared/api/entity';
import {PROFILE_STATE} from '../../../../../common/constants';
import {NavigationService} from '../../navigation';

@Component({
    selector: 'tfb-bo-card-box-corporate-content',
    template: `
        <div class="col-sm-4">
            <tfl-bo-data-item label="CUSTOMER.TABLE.NAME">{{ customer.name }}</tfl-bo-data-item>
            <tfl-bo-data-item label="CUSTOMER.TABLE.ADDRESS">{{ customer.address }}</tfl-bo-data-item>
            <tfl-bo-data-item label="CUSTOMER.TABLE.OPENING_DATE">{{ customer.opening_date }}</tfl-bo-data-item>
            <tfl-bo-data-item label="CUSTOMER.TABLE.APPROVING_DATE">{{ customer.approvingDate }}</tfl-bo-data-item>
        </div>

        <!-- Second column -->
        <div class="col-sm-4">
            <tfl-bo-data-item label="CUSTOMER.TABLE.SIGNATORY">{{ customer.authorized_user_name }}</tfl-bo-data-item>
            <tfl-bo-data-item label="CUSTOMER.TABLE.EMAIL">{{ customer.email }}</tfl-bo-data-item>
            <tfl-bo-data-item label="CUSTOMER.TABLE.PHONE">{{ customer.phone }}</tfl-bo-data-item>
            <tfl-bo-data-item label="CUSTOMER.TABLE.USER_EMAIL">{{ customer.userEmail }}</tfl-bo-data-item>
        </div>

        <!-- Third column -->
        <div *ngIf="customer.state == STATE.ACTIVE || customer.state == STATE.PENDING" class="col-sm-4">
            <tfl-bo-data-item label="CUSTOMER.TABLE.TARIFF">
                <a (click)="openTariffDetailView(customer.tariff.id)">{{ customer.tariff.name  }}</a>
            </tfl-bo-data-item>

            <tfl-bo-data-item label="CUSTOMER.TABLE.MIN_TOTAL_ASSET">{{ customer.min_total_asset | money }}</tfl-bo-data-item>
            <tfl-bo-data-item label="CUSTOMER.TABLE.INTRODUCER">{{ customer.actualIntroducer.name}}</tfl-bo-data-item>
        </div>

        <div *ngIf="customer.state == STATE.NEW" class="col-sm-4">
            <tfl-bo-data-item label="CUSTOMER.TABLE.INTRODUCER_FROM_APPLICATION">{{ customer.applicationIntroducer}}</tfl-bo-data-item>
            <tfl-bo-data-item *ngIf="!customer.actualIntroducer.isSystem" label="CUSTOMER.TABLE.INTRODUCER">{{ customer.actualIntroducer.name}}</tfl-bo-data-item>
        </div>
    `
})

export class CardBoxCorporateContentComponent {

    @Input('customer') customer: CustomerProfile;

    readonly STATE = PROFILE_STATE;

    constructor(private _navigation: NavigationService) {}

    openTariffDetailView(id: number) {
        this._navigation.configuration.tariff.detail(id);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/card-box/card-content/card-box-corporate.content.component.ts